import React from "react";

interface ICardSolutionProps {
  icon: any;
  title: string;
  descriptions: string[];
}
export const CardSolution: React.FC<ICardSolutionProps> = ({
  descriptions,
  title,
  icon,
}) => {
  return (
    <div
      className="bg-[#00273C] text-white p-6 rounded-lg shadow-lg"
    >
      <div className="mb-4">
        {icon}
      </div>
      <h3 className="text-xl font-semibold mb-3">{title}</h3>
      <ul className="text-gray-300 space-y-2">
        {descriptions.map((desc, i) => (
          <li key={i} className="flex items-start">
            • {desc}
          </li>
        ))}
      </ul>
    </div>
  );
};
